import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TtListLegacyComponent } from './tt-list-legacy.component';
import { ReversePipe } from './reverse.pipe';
import { FilterListPipe } from './filter-list.pipe';
import { FilterSecondListPipe } from './filter-second-list.pipe';
import { FilterGlyphPipe } from './filter-glyph.pipe';
import { TtNouisliderModule } from '../tt-nouislider/tt-nouislider.module';

@NgModule({
    declarations: [
        TtListLegacyComponent,
        ReversePipe,
        FilterListPipe,
        FilterSecondListPipe,
        FilterGlyphPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        TtNouisliderModule
    ],
    exports: [
        TtListLegacyComponent,
        ReversePipe,
        FilterListPipe,
        FilterSecondListPipe,
        FilterGlyphPipe
    ]
})
export class TtListLegacyModule { }
